import React  from "react";
import { DirectionalHint, FontIcon, mergeStyles, TooltipDelay, TooltipHost } from "office-ui-fabric-react";
import { iconClass } from "../../styles/containerStyles";

export const inProgressOrdersColumns = (t: any) => [
  {
    key: "Number",
    name: t('orders.columns.orderNumber'),
    fieldName: "number",
    minWidth: 50,
    maxWidth: 100,
    isResizable: true,
  },
  {
    key: "CreatedAt",
    name: t('orders.columns.orderDate'),
    fieldName: "createdAt",
    minWidth: 50,
    maxWidth: 100,
    isResizable: true,
  },
  {
    key: "ReceivingDate",
    name: t('orders.columns.plannedPickupDate'),
    fieldName: "receivingDate",
    minWidth: 50,
    maxWidth: 100,
    isResizable: true,
  },
  {
    key: "Company",
    name: t('orders.columns.client'),
    fieldName: "company",
    minWidth: 150,
    maxWidth: 250,
    isResizable: true,
  },
  {
    key: "ReceptionPlace",
    name: t('orders.columns.receptionPlace'),
    fieldName: "receptionPlace",
    minWidth: 100,
    maxWidth: 300,
    isResizable: true,
  },
  {
    key: "Type",
    name: t('orders.columns.type'),
    fieldName: "type",
    minWidth: 50,
    maxWidth: 80,
    isResizable: true,
    onRender: (item: any) => {
      const map: any = { "Pojazd": t('orders.typeValues.vehicle'), "Kontener": t('orders.typeValues.container'), "Tonaż": t('orders.typeValues.tonnage'), "Specjalne": t('orders.typeValues.special') };
      return map[item.type] !== undefined ? map[item.type] : item.type;
    },
  },
  {
    key: "Vehicle",
    name: t('orders.columns.vehicle'),
    fieldName: "vehicle",
    minWidth: 50,
    maxWidth: 100,
    isResizable: true,
    onRender: (item: any) => ( item.notificationSent ?
      <>{item.vehicle} &nbsp; <TooltipHost
      content={t('orders.columns.smsSentTooltip')}
      delay={TooltipDelay.zero}
      directionalHint={DirectionalHint.bottomCenter}
    ><FontIcon iconName="message" className={iconClass}/> </TooltipHost></> : item.vehicle
    ),
  },
  {
    key: "ContactPhone",
    name: t('orders.columns.phone'),
    fieldName: "contactPhone",
    minWidth: 50,
    maxWidth: 90,
    isResizable: true,
  },
  {
    key: "route",
    name: t('orders.columns.route'),
    fieldName: "route",
    minWidth: 25,
    maxWidth: 50,
    isResizable: true,
  },
  {
    key: "sequenceInRoute",
    name: t('orders.columns.sequenceInRoute'),
    fieldName: "sequenceInRoute",
    minWidth: 25,
    maxWidth: 50,
    isResizable: true,
  },
  {
    key: "receptionCount",
    name: t('orders.columns.receivedCount'),
    fieldName: "receptionCount",
    minWidth: 25,
    maxWidth: 50,
    isResizable: true,
  },
  {
    key: "IsFromCuo",
    name: t('orders.columns.source'),
    fieldName: "isFromCuo",
    minWidth: 50,
    maxWidth: 80,
    isResizable: true,
  },
  {
    key: "CuoOrderNumber",
    name: t('orders.columns.cuoOrderNumber'),
    fieldName: "cuoOrderNumber",
    minWidth: 80,
    maxWidth: 120,
    isResizable: true,
  },
];
